<template>
  <div class="guarantor-new wrapper">
    <div class="steps">
      <Steps :current="currentStep" direction="vertical">
        <Step title="选择地区" content="选择项目所在地区"></Step>
        <Step title="选择行业" content="选择所属行业领域"></Step>
        <Step title="项目信息" content="选择或填写项目信息"></Step>
        <Step title="保证金信息" content="填写保证金信息"></Step>
        <Step title="提交" content=""></Step>
      </Steps>
    </div>
    <div class="views">
      <router-view
        :data="guaranteeModel"
        @go-backward="goBackward"
        @finish-step1="finishStep1"
        @finish-step2="finishStep2"
        @finish-step3="finishStep3"
        @finish-step4="finishStep4"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'guarantor-new',
  props: {
  },
  data () {
    return {
      currentStep: 0,
      guaranteeModel: {
        cityId: null,
        cities: null,
        guarantorCity: null,
        industryId: null,
        guarantorIndustry: null
      }
    }
  },
  watch: {
  },
  mounted () {
    let pathSegs = this.$route.path.split('/')
    let step = pathSegs[pathSegs.length - 1]
    if (step.toLowerCase().indexOf('step') === 0) {
      this.currentStep = parseInt(step.substr(4)) - 1
    }
    if (this.$route.params.orderNumber) {
      this.getGuaranteeDetail()
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getGuaranteeDetail () {
      this.$Api.Receipt.getReceiptDetail(this.$route.params.orderNumber).then((res) => {
        Object.assign(this.guaranteeModel, res)
        this.guaranteeModel.project.cost /= 100
        this.guaranteeModel.amountCostRatio /= 100
        this.guaranteeModel.amount /= 100
        if (this.guaranteeModel.fee) {
          this.guaranteeModel.fee /= 100
        } else {
          this.guaranteeModel.fee  = null
        }
        this.guaranteeModel.counterTotal /= 100
        this.guaranteeModel.counterCash /= 100
        this.guaranteeModel.counter3rdparty /= 100
        this.guaranteeModel.counterMortgage /= 100
        this.guaranteeModel.counterOther /= 100
        if (this.guaranteeModel.attachments && this.guaranteeModel.attachments instanceof Array && this.guaranteeModel.attachments.length) {
          this.guaranteeModel.attachments.forEach((att) => {
            if (!att.urls) {
              att.urls = []
            }
          })
        }
        this.currentStep = 3
        this.$router.replace({path: '/receipts/new/step4'})
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    goBackward () {
      this.currentStep -= 1
      if (this.currentStep === 3) {
        this.guaranteeModel.amount /= 100
        this.guaranteeModel.fee /= 100
      }
      this.$router.push({path: '/receipts/new/step' + (this.currentStep + 1)})
    },
    finishStep1 (model) {
      console.log(model)
      this.guaranteeModel.cityId = model.cityId
      this.guaranteeModel.cities = model.cities
      this.guaranteeModel.cityName = model.guarantorCity[0].cityName
      this.guaranteeModel.guarantorCity = model.guarantorCity
      this.currentStep = 1
      this.$router.replace({path: '/receipts/new/step2'})
    },
    finishStep2 (guarantorIndustry) {
      console.log('guarantorIndustry', guarantorIndustry)
      if (this.checkRolePermitted(['保证人'])) {
        this.guaranteeModel.industryId = guarantorIndustry.industryId
        this.guaranteeModel.industryName = guarantorIndustry.industryName
        this.guaranteeModel.guarantorIndustry = guarantorIndustry
      } else if (this.checkRolePermitted(['监管人','总监管人','管理员'])) {
        this.guaranteeModel.industryId = guarantorIndustry.industry.id
        this.guaranteeModel.industryName = guarantorIndustry.industry.name
        this.guaranteeModel.guarantorIndustry = guarantorIndustry
      }
      this.currentStep = 2
      this.$router.replace({path: '/receipts/new/step3'})
    },
    finishStep3 (model) {
      console.log(model)
      model.project.cost /= 100
      Object.assign(this.guaranteeModel, model)
      this.currentStep = 3
      this.$router.replace({path: '/receipts/new/step4'})
    },
    finishStep4 (model) {
      console.log(model)
      Object.assign(this.guaranteeModel, model)
      this.guaranteeModel.contractOssKeys = []
      this.guaranteeModel.contractOssKeys = model.contractOssKeys
      this.currentStep = 4
      this.$router.replace({path: '/receipts/new/step5'})
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new.wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  align-items: stretch;
  height: 100%;
  .steps{
    width: 180px;
  }
  .views {
    flex: 1;
    overflow: hidden;
  }
}
</style>
